var _circle, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _rect, _rect2, _g, _path1;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPoi(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 28,
    cy: 28,
    r: 28,
    fill: "#2C2C2C"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_423_421",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 8,
    y: 8,
    width: 41,
    height: 41
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M48.6654 28.3327C48.6654 39.5621 39.5621 48.6654 28.3327 48.6654C17.1033 48.6654 8 39.5621 8 28.3327C8 17.1033 17.1033 8 28.3327 8C39.5621 8 48.6654 17.1033 48.6654 28.3327Z",
    fill: "#D9D9D9"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_423_421)"
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M26.9854 33.2277L33.1352 27.1348L36.5803 29.925L29.0353 37.47L26.9854 35.42V33.2277Z",
    fill: "#BDBDBD"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M27.1847 30.7791L23.4833 27.1348L21.0632 29.7257L23.3979 32.0319L25.8465 32.1458L27.1847 30.7791Z",
    fill: "#BDBDBD"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M22.4299 32.9715L20.5223 31.4055L19.2695 34.3096L20.807 37.0999L22.6861 35.2777L22.4299 32.9715Z",
    fill: "#BDBDBD"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M23.8535 36.3881L21.4334 38.6658L24.4514 42.2817L27.8965 38.5519L25.8465 36.3881H23.8535Z",
    fill: "#BDBDBD"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M29.0353 39.947L26.8999 42.3956L31.3985 41.997L29.0353 39.947Z",
    fill: "#BDBDBD"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M30.4304 38.5519C31.2656 39.3966 32.9758 41.1257 33.1352 41.2852L36.5803 38.6658L33.3915 35.42L30.4304 38.5519Z",
    fill: "#BDBDBD"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M34.5873 34.3096L36.7796 32.1458L37.5768 36.929L34.5873 34.3096Z",
    fill: "#BDBDBD"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.4769 42.0736C32.9133 42.0736 36.5097 38.4772 36.5097 34.0408C36.5097 34.0405 36.5097 34.0402 36.5097 34.0399H41.9561C41.9561 35.925 41.5607 37.7892 40.7953 39.5119C40.0299 41.2347 38.9117 42.7778 37.5128 44.0414C36.1139 45.305 34.4655 46.2612 32.674 46.848C30.8825 47.4349 28.9879 47.6394 27.1125 47.4483C25.2371 47.2573 23.4226 46.675 21.7862 45.7389C20.1499 44.8029 18.7281 43.5341 17.6127 42.0143C16.4974 40.4945 15.7132 38.7577 15.3109 36.916C14.9087 35.0743 14.8972 33.1687 15.2773 31.3223L20.6078 32.4196C20.5005 32.9432 20.4441 33.4854 20.4441 34.0408C20.4441 38.4772 24.0405 42.0736 28.4769 42.0736Z",
    fill: "#AAAAAA"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.477 42.0714C32.9133 42.0714 36.5097 38.475 36.5097 34.0386C36.5097 32.7701 36.2157 31.5702 35.692 30.5035L40.5801 28.1094C41.3586 29.6989 41.8164 31.4262 41.9274 33.1926C42.0384 34.9591 41.8003 36.7301 41.2269 38.4046C40.6534 40.079 39.7557 41.6241 38.5851 42.9517C37.4145 44.2792 35.9939 45.3632 34.4044 46.1417C32.8149 46.9202 31.0876 47.378 29.3211 47.489C27.5547 47.6 25.7837 47.362 24.1092 46.7885C22.4348 46.215 20.8896 45.3174 19.5621 44.1468C18.2346 42.9762 17.1506 41.5556 16.3721 39.966L21.2608 37.5716C22.5681 40.2367 25.3083 42.0714 28.477 42.0714Z",
    fill: "#AAAAAA"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_423_421",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 17,
    y: 8,
    width: 22,
    height: 22
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 17.8027,
    y: 8,
    width: 21.1717,
    height: 21.1717,
    fill: "#179C4B"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_423_421)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask2_423_421",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 16,
    y: 6,
    width: 25,
    height: 25
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 16.0381,
    y: 6.23438,
    width: 24.7004,
    height: 24.7004,
    fill: "black"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_423_421)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M28.3887 28.1829C28.1486 28.1829 27.9084 28.14 27.6683 28.0542C27.4282 27.9685 27.2137 27.8398 27.0251 27.6683C25.9101 26.6391 24.9238 25.6357 24.0662 24.6579C23.2085 23.6802 22.4924 22.7325 21.9177 21.8148C21.3431 20.8971 20.9057 20.0138 20.6055 19.1647C20.3054 18.3156 20.1553 17.5051 20.1553 16.7332C20.1553 14.1603 20.9829 12.1105 22.6382 10.5839C24.2934 9.05726 26.2103 8.29395 28.3887 8.29395C30.5672 8.29395 32.484 9.05726 34.1393 10.5839C35.7945 12.1105 36.6222 14.1603 36.6222 16.7332C36.6222 17.5051 36.4721 18.3156 36.1719 19.1647C35.8717 20.0138 35.4343 20.8971 34.8597 21.8148C34.2851 22.7325 33.5689 23.6802 32.7113 24.6579C31.8536 25.6357 30.8673 26.6391 29.7524 27.6683C29.5637 27.8398 29.3493 27.9685 29.1092 28.0542C28.869 28.14 28.6289 28.1829 28.3887 28.1829ZM28.3887 18.5858C28.9548 18.5858 29.4394 18.3842 29.8424 17.9811C30.2455 17.578 30.4471 17.0934 30.4471 16.5274C30.4471 15.9613 30.2455 15.4768 29.8424 15.0737C29.4394 14.6706 28.9548 14.469 28.3887 14.469C27.8227 14.469 27.3381 14.6706 26.935 15.0737C26.5319 15.4768 26.3304 15.9613 26.3304 16.5274C26.3304 17.0934 26.5319 17.578 26.935 17.9811C27.3381 18.3842 27.8227 18.5858 28.3887 18.5858Z",
    fill: "#E8C877"
  })))), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.6477 26.9805C24.3072 26.6214 23.9821 26.2655 23.6726 25.9126C22.746 24.8563 21.9723 23.8324 21.3514 22.8409C21.3154 22.7833 21.2798 22.7258 21.2447 22.6685C17.4903 25.0609 15 29.2612 15 34.043C15 41.4866 21.0342 47.5209 28.4778 47.5209C35.9214 47.5209 41.9557 41.4866 41.9557 34.043C41.9557 29.1784 39.3784 24.9157 35.5149 22.5459C35.456 22.6439 35.3956 22.7422 35.3338 22.8409C34.713 23.8324 33.9393 24.8563 33.0127 25.9126C32.7302 26.2346 32.4348 26.5592 32.1265 26.8864C34.7281 28.2158 36.5092 30.9218 36.5092 34.0439C36.5092 38.4803 32.9128 42.0767 28.4764 42.0767C24.04 42.0767 20.4436 38.4803 20.4436 34.0439C20.4436 30.9938 22.1436 28.3408 24.6477 26.9805Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPoi);
export default __webpack_public_path__ + "static/media/poi.055a714a5abfb933b18d48ae60a7318f.svg";
export { ForwardRef as ReactComponent };